export const LangText: any = {
    us: {
        product_name: 'EcoFlow DELTA 3 Series',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
};
